import { defineStore } from 'pinia';
import Buildings from '@/roc/building';
import Wonders from '@/roc/wonders';
import Artifacts from '@/roc/museum';
import { readonly, ref } from 'vue';
export const useApplicationStore = defineStore('Application', () => {
    const selectedEra = ref(null);
    const editable = ref(true);
    const newBuildingTemplateId = ref(null);
    const displayMode = ref('normal');
    const showBonusHappiness = ref(false);
    const viewingBonuses = ref(false);
    return {
        // state
        selectedEra: readonly(selectedEra),
        editable: readonly(editable),
        newBuildingTemplateId: readonly(newBuildingTemplateId),
        displayMode: readonly(displayMode),
        showBonusHappiness: readonly(showBonusHappiness),
        viewingBonuses: readonly(viewingBonuses),
        // actions
        changeEra(era) {
            selectedEra.value = era;
        },
        disableEditing() {
            editable.value = false;
        },
        enableEditing() {
            editable.value = true;
        },
        toggleDisplayMode() {
            displayMode.value = displayMode.value === 'normal' ? 'happiness' : 'normal';
        },
        toggleBonusHappiness() {
            showBonusHappiness.value = !showBonusHappiness.value;
        },
        queueBuildingCreation(templateId) {
            newBuildingTemplateId.value = templateId;
        },
        clearBuildingCreationQueue() {
            newBuildingTemplateId.value = null;
        },
        maxUsedBuildingId() {
            let maxID = 0;
            const allBuildings = [...Buildings, ...Wonders, ...Artifacts];
            for (let i = 0; i < allBuildings.length; i++) {
                const id = parseInt(allBuildings[i].id);
                if (id > maxID) {
                    maxID = id;
                }
            }
            return maxID;
        },
        openBonuses() {
            viewingBonuses.value = true;
        },
        closeBonuses() {
            viewingBonuses.value = false;
        }
    };
});
